import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { Link } from "react-router-dom";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Field, FormikProvider, useFormik } from "formik";
import CustomInput from "../../../CustomControls/CustomInput";
import * as Yup from "yup";

import { post } from "../../../helpers/api_helper";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { SVGICON } from "../../../constant/theme";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import {
  POST_AdvanceReceiptCancelled,
  POST_AdvanceReceiptExport,
  POST_AdvanceReceiptWhatsAppMessageSend,
  POST_GetAdvanceReceiptList,
  POST_GetAdvanceReceiptPrint,
  POST_GetCustomerDDLListAJAX,
} from "../../../helpers/url_helper";
import moment from "moment";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { useFilter } from "../../../../context/FilterContext";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";

const AdvanceReceipt = () => {
  const { filter, updateFilter } = useFilter();

  const isFilterExpanded =
    JSON.parse(localStorage.getItem("userDetails"))?.IsFilterExpanded === true;
  const [showFilter, setShowFilter] = useState(isFilterExpanded);
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "advance-receipt" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "advance-receipt" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "advance-receipt" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "advance-receipt" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const [advanceReceiptList, setAdvanceReceiptList] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Settled", value: 1 },
    { label: "Unsettled", value: 0 },
  ];

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      AdvanceReceiptNo:
        filter && filter?.page == "advance-receipt"
          ? filter?.AdvanceReceiptNo
          : "",
      FromDate:
        filter && filter?.page == "advance-receipt"
          ? filter?.FromDate
          : new Date(),
      ToDate:
        filter && filter?.page == "advance-receipt"
          ? filter?.ToDate
          : new Date(),
      CustomerIDEncrypted:
        filter && filter?.page == "advance-receipt"
          ? filter?.CustomerIDEncrypted
          : "",
      CustomerName:
        filter && filter?.page == "advance-receipt" ? filter?.CustomerName : "",
      Status: filter && filter?.page == "advance-receipt" ? filter?.Status : -1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: {
      AdvanceReceiptNo,
      Status,
      FromDate,
      ToDate,
      CustomerIDEncrypted,
      CustomerName,
    },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      AdvanceReceiptNo: "",
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      Status: -1,
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "advance-receipt",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      AdvanceReceiptNo: AdvanceReceiptNo,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerName: CustomerName,
      Status: Status,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      AdvanceReceiptNo: AdvanceReceiptNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
    };

    await post(POST_GetAdvanceReceiptList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setAdvanceReceiptList(response?.List);
        setIsLoading(false);

        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const exportReport = () => {
    setIsLoading(true);

    let payload = {
      Search: "",
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      AdvanceReceiptNo: AdvanceReceiptNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
    };
    post(POST_AdvanceReceiptExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const printAdvanceReceipt = async (advanceReceiptID) => {
    setIsLoading(true);
    await post(POST_GetAdvanceReceiptPrint, {
      AdvanceReceiptIDEncrypted: advanceReceiptID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let iframe = document.getElementById("iFrameAdvanceReceipt");
          if (iframe) {
            iframe.setAttribute("srcDoc", response?.HTMLContents);
            setTimeout(() => {
              iframe.contentWindow.print();
            }, 300);
          }
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerDDL_AJAX = async (inputValue) => {
    return await post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const loadOptionsCustomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const [showCancelAdvanceReceiptModal, setShowCancelAdvanceReceiptModal] =
    useState(false);

  const validationSchemaCancelAdvanceReceipt = Yup.object().shape({
    CancelReason: Yup.string()
      .trim()
      .required("Cancel Reason is required field"),
  });

  const formikCancelAdvanceReceipt = useFormik({
    validationSchema: validationSchemaCancelAdvanceReceipt,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitCancelAdvanceReceipt(values, formikHelpers),
    initialValues: {
      AdvanceReceiptIDEncrypted: "",
      ReceiptNo: "",
      CancelReason: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikCancelAdvanceReceipt;

  const cancelAdvanceReceipt = (advanceReceiptID, receiptNo) => {
    formikCancelAdvanceReceipt.resetForm();
    formikCancelAdvanceReceipt.setFieldValue("ReceiptNo", receiptNo);
    formikCancelAdvanceReceipt.setFieldValue(
      "AdvanceReceiptIDEncrypted",
      advanceReceiptID
    );
    setShowCancelAdvanceReceiptModal(true);
  };

  const handleValidSubmitCancelAdvanceReceipt = (values) => {
    setIsLoading(true);
    post(POST_AdvanceReceiptCancelled, {
      AdvanceReceiptIDEncrypted: values?.AdvanceReceiptIDEncrypted,
      CancelReason: values?.CancelReason,
      ModifiedByEncrypted: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          getData(currentPage, currentSizePerPage);
          setShowCancelAdvanceReceiptModal(false);
        } else {
          setIsLoading(false);
          errorMessage(response?.Message);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const SendAdvanceReceiptWhatsAppMessage = async (
    advanceReceiptID,
    mobileNo
  ) => {
    if (!mobileNo) {
      warningMessage(
        "Please provide a mobile number to send the whatsApp message."
      );
      return;
    }

    if (!advanceReceiptID) {
      warningMessage("Something went wrong!");
      return;
    }

    setIsLoading(true);

    let payload = {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      AdvanceReceiptIDEncrypted: advanceReceiptID,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
    };

    await post(POST_AdvanceReceiptWhatsAppMessageSend, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          getData(currentPage, currentSizePerPage);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Advance Receipt</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore me-2" aria-hidden="true"></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 54 && x?.IsExport)
                    ?.length > 0 ? (
                    <Link
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={exportReport}
                    >
                      <i className="fa-solid fa-file-excel" /> Export Report
                    </Link>
                  ) : (
                    ""
                  )}
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 54 && x?.IsAdd)
                    ?.length > 0 ? (
                    <Link
                      to="/add-advance-receipt"
                      className="btn btn-outline-primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add Advance Receipt
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={2}>
                            <Field
                              label="Receipt No"
                              name="AdvanceReceiptNo"
                              placeholder={"Search Receipt No"}
                              component={CustomInput}
                              autoFocus={isFilterExpanded}
                            />
                          </Col>
                          <Col lg={3}>
                            <label className="mb-1">Receipt Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              loadOptionsFn={loadOptionsCustomer}
                              component={CustomSelectAsync}
                              title={CustomerName}
                              labelFieldName="CustomerName"
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="Status"
                              name="Status"
                              placeholder={"Select Status"}
                              options={statusOptions}
                              component={CustomSelect}
                              isClearable={false}
                              menuPosition="fixed"
                            />
                          </Col>

                          <Col lg={2}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  // className="btn btn-outline-primary btn-sm"
                                  className="btn btn-primary btn-sm"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div
                  id="AdvanceReceipt-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="AdvanceReceipt-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="6%" style={{ minWidth: "90px" }}></th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("ReceiptNo");
                          }}
                        >
                          Receipt No{" "}
                          <span className="ml-1">
                            {sortBy == "ReceiptNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>

                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("ReceiptDate");
                          }}
                        >
                          Receipt Date{" "}
                          <span className="ml-1">
                            {sortBy == "ReceiptDate" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "44%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerName");
                          }}
                        >
                          Customer Name{" "}
                          <span className="ml-1">
                            {sortBy == "CustomerName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                            textAlign: "right",
                          }}
                          onClick={() => {
                            handleClickSorting("AmountReceived");
                          }}
                        >
                          Amount{" "}
                          <span className="ml-1">
                            {sortBy == "AmountReceived" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                            textAlign: "right",
                          }}
                          onClick={() => {
                            handleClickSorting("SettledAmount");
                          }}
                        >
                          Settled Amount{" "}
                          <span className="ml-1">
                            {sortBy == "SettledAmount" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                            textAlign: "right",
                          }}
                          onClick={() => {
                            handleClickSorting("BalanceAmount");
                          }}
                        >
                          Balance Amount{" "}
                          <span className="ml-1">
                            {sortBy == "BalanceAmount" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {advanceReceiptList?.length > 0 ? (
                        advanceReceiptList?.map((item, indx) => (
                          <tr key={indx}>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 54 && x?.IsEdit
                              )?.length > 0 ? (
                                parseFloat(item.SettledAmount) == 0 ? (
                                  <Link
                                    to={`/edit-advance-receipt/${window.btoa(
                                      item.AdvanceReceiptIDEncrypted
                                    )}`}
                                    className="icon-box icon-box-md me-1"
                                    title="Edit"
                                  >
                                    {SVGICON.EditPrimary}
                                  </Link>
                                ) : (
                                  <span className="ms-4">&nbsp;</span>
                                )
                              ) : (
                                ""
                              )}

                              <Link
                                to="#"
                                className="icon-box icon-box-md me-1"
                                title="Print"
                                onClick={() => {
                                  printAdvanceReceipt(
                                    item.AdvanceReceiptIDEncrypted
                                  );
                                }}
                              >
                                {SVGICON.Printer}
                              </Link>

                              {AuthUser?.UserType == 1 &&
                              AuthUser?.Permissions?.Whatsup == 1 &&
                              formsList?.filter(
                                (x) =>
                                  x?.FormID == 81 && (x?.IsAdd || x?.IsEdit)
                              )?.length > 0 ? (
                                <>
                                  <Link
                                    className="icon-box icon-box-md me-1"
                                    title="Send Advance Receipt in WhatsApp"
                                    onClick={() => {
                                      SendAdvanceReceiptWhatsAppMessage(
                                        item?.AdvanceReceiptIDEncrypted,
                                        item?.MobileNo
                                      );
                                    }}
                                  >
                                    {SVGICON.WhatsApp}
                                  </Link>
                                </>
                              ) : (
                                ""
                              )}

                              {(AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 54 && x?.IsEdit
                                )?.length > 0) &&
                              parseFloat(item.SettledAmount) == 0 ? (
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="Delete"
                                  onClick={() => {
                                    cancelAdvanceReceipt(
                                      item.AdvanceReceiptIDEncrypted,
                                      item.ReceiptNo
                                    );
                                  }}
                                >
                                  {SVGICON.DeleteDanger}
                                </Link>
                              ) : (
                                ""
                              )}
                            </td>

                            <td style={{ verticalAlign: "top" }}>
                              {item.ReceiptNo}
                            </td>

                            <td style={{ verticalAlign: "top" }}>
                              {item.ReceiptDate}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.CustomerName}
                            </td>
                            <td
                              className="pe-4"
                              style={{
                                textAlign: "right",
                                verticalAlign: "top",
                              }}
                            >
                              {item.AmountReceived}
                            </td>
                            <td
                              className="pe-4"
                              style={{
                                textAlign: "right",
                                verticalAlign: "top",
                              }}
                            >
                              {item.SettledAmount}
                            </td>
                            <td
                              className="pe-4"
                              style={{
                                verticalAlign: "top",
                                textAlign: "right",
                              }}
                            >
                              {item.BalanceAmount}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={12} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
          <Modal
            className="fade"
            show={showCancelAdvanceReceiptModal}
            onHide={setShowCancelAdvanceReceiptModal}
            size="lg"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikCancelAdvanceReceipt}>
                <Form onSubmit={formikCancelAdvanceReceipt.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>
                      Cancel Advance Receipt -{" "}
                      {formikCancelAdvanceReceipt.values.ReceiptNo}
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowCancelAdvanceReceiptModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row className="ps-2 pe-2">
                      <Col lg={12}>
                        <Field
                          label="Cancel Reason"
                          name="CancelReason"
                          placeholder={"Cancel Reason"}
                          component={CustomInput}
                          maxLength={500}
                          required
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() => setShowCancelAdvanceReceiptModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
        </div>
      </div>
      <div style={{ display: "none" }}>
        <iframe
          id={`iFrameAdvanceReceipt`}
          title="Advance Receipt"
          width="100%"
          style={{ height: "100vh", display: "none" }}
          frameBorder="0"
          srcDoc=""
        ></iframe>
      </div>
    </>
  );
};

export default AdvanceReceipt;
